export default {
  title: {
    index: '职位自动化发布管理',
    editor: '编辑字段映射关系',
    mappingManagement: '{channelName} - {fieldTypeName} - 对应关系管理'
  },
  label: {
    channel: '平台',
    fieldType: '字段',
    defaultValue: '默认值',
    selfField: '菁客字段的值',
    otherField: '{channelName}字段的值',
    mappingType: 'Mapping类型',
    jobCustomField: '职位自定义字段',
    customMapping: '自定义Mapping',
    salaryType: '薪资类型',
    minSalary: '最低薪资',
    maxSalary: '最高薪资',
    salaryMonths: '薪资月数',
    fixedValue: '固定值',
    customFields: '自定义字段'
  },
  placeholder: {
    minSalary: '最低薪资',
    maxSalary: '最高薪资',
    defaultValue: '如果下方配置列表为空或者匹配不到对应项，则默认使用该值',
    inputFieldMappingValue: '请输入{channelName}页面上“{fieldTypeName}”字段的对应值'
  },
  btn: {
    addMapItem: '点击这里新增一行'
  },
  message: {
    defaultIsRequired: '默认值不能为空',
    mappingHasEmpty: '配置列表中存在空值，请填写或者移除该行'
  }
}
